export const hasImeiRestriction = (
    isInternalType: boolean,
    isSuperUser: boolean
) => !isInternalType && isSuperUser;
